import React from 'react'
import { find } from 'lodash'
import List from '../../crud/list'
import menuItems from './menuItems'
import orderItemStatusOptions from './order-item-status-options'

const columns = [
  {
    title: 'Product',
    prop: 'product_id',
    references: 'admin/products',
    referenceProp: 'name'
  },
  {
    title: 'Status',
    prop: 'item_status',
    format: value => {
      const option = find(orderItemStatusOptions, { value })
      return option ? option.name : value
    }
  },
  {
    title: 'Description',
    prop: 'item_description'
  },
  {
    title: 'Created',
    prop: 'created_at',
    format: 'dateWithTime'
  },
  {
    title: 'Updated At',
    prop: 'updated_at',
    format: 'dateWithTime'
  }
]

const defaults = {
  order: [{ column: 'id', direction: 'asc' }]
}

const OrderItems = props => {
  const { orderId } = props.params

  return (
    <List
      title='Order Items'
      apiPath='admin/order_items'
      fixedFilters={{
        order_id: orderId
      }}
      columns={columns}
      defaults={defaults}
      buildMenuItems={menuItems}
      locationPathname={props.location.pathname}
      locationSearch={props.location.search}
    />
  )
}

export default OrderItems
